import React from 'react';
import { connect } from 'react-redux';

import { fallbackFunc } from '../../utils/utils';
import { keycloakConfigSelector } from '../../helpers/selectors';
import { FormattedMessage } from 'react-intl';

/**
 * @typedef {object} LoginFormProps
 * @property {Function} [onDirectSso] - redirects to the Keycloak login page
 */
const LoginForm = (props) => {
  const { keycloakConfig, onDirectSso = fallbackFunc } = props;

  if (!keycloakConfig) return null;

  const handleSsoButtonClick = () => {
    onDirectSso(keycloakConfig);
  };

  return (
    <div className="form-content login-form">
      <div className="sso-container">
        <button
          type="button"
          className="sso-button primary-btn"
          onClick={handleSsoButtonClick}
        >
          <FormattedMessage id="sso.login.button" />
        </button>
      </div>
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    keycloakConfig: keycloakConfigSelector(state)
  };
};

export default connect(mapStateToProps)(LoginForm);
